import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from 'recharts';

const COLORS = ['#10b981','#3b82f6','#f59e0b','#ef4444','#8b5cf6','#ec4899','#06b6d4','#84cc16','#f97316','#6366f1'];

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-3 shadow-sm text-sm space-y-0.5">
      <p className="font-medium text-slate-700">{d.name}</p>
      <p className="text-slate-600">${d.amount.toLocaleString('en-AU', { minimumFractionDigits: 2 })}</p>
      {d.overBudget > 0 && <p className="text-rose-500">Over budget by ${d.overBudget.toLocaleString('en-AU', { minimumFractionDigits: 2 })}</p>}
    </div>
  );
};

const CustomLabel = ({ x, y, width, height, value, index, data }) => {
  const entry = data[index];
  const label = `$${value.toLocaleString('en-AU', { minimumFractionDigits: 2 })}`;
  return (
    <text x={x + width + 6} y={y + height / 2} dy={4} fontSize={11} fill={entry?.overBudget > 0 ? '#ef4444' : '#64748b'}>
      {label}{entry?.overBudget > 0 && <tspan fill="#ef4444"> (+${entry.overBudget.toLocaleString('en-AU', { minimumFractionDigits: 2 })})</tspan>}
    </text>
  );
};

const CustomYAxisTick = ({ x, y, payload, data }) => {
  const entry = data?.find(d => d.name === payload.value);
  const isOver = entry?.overBudget > 0;
  return (
    <text x={x} y={y} dy={4} textAnchor="end" fontSize={11} fill={isOver ? '#ef4444' : '#64748b'}>
      {payload.value}
    </text>
  );
};

export default function SpendingExpandModal({ open, onClose, data }) {
  const barHeight = Math.max(400, data.length * 36);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-sm font-semibold text-slate-500 uppercase tracking-wide">Spending by Category</DialogTitle>
        </DialogHeader>
        <div style={{ height: barHeight }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="vertical" margin={{ left: 0, right: 220, top: 0, bottom: 0 }}>
              <XAxis
                type="number"
                tickFormatter={v => `$${v >= 1000 ? (v / 1000).toFixed(1) + 'k' : v}`}
                fontSize={11} axisLine={false} tickLine={false}
              />
              <YAxis
                type="category"
                dataKey="name"
                fontSize={11}
                width={130}
                axisLine={false}
                tickLine={false}
                tick={<CustomYAxisTick data={data} />}
              />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="amount" radius={[0, 4, 4, 0]} maxBarSize={24} label={<CustomLabel data={data} />}>
                {data.map((entry, i) => <Cell key={i} fill={entry.overBudget > 0 ? '#ef4444' : COLORS[i % COLORS.length]} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </DialogContent>
    </Dialog>
  );
}